import { SET_CLIENT_FACTSHEET } from "../actions/action-types.js";

export default function clientFactSheet(state = {}, {type, payload}) {
    switch (type) {
        case SET_CLIENT_FACTSHEET:
            return (state = payload)
        default:
            return state
    }
}